import formatDateTime from "./formatDateTime";
import parseDate from "./parseDate";

const renderDateTime = (value: unknown) => {
  const dateValue = parseDate(value);

  if (!dateValue) {
    return "-";
  }

  return formatDateTime(dateValue);
};

export default renderDateTime;
